import { Box, Button, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { FEATURED_FILTER_URL_PARAM } from '../../../../config/filter';
import { APP_URLS } from '../../../../routes/urls';
import { useFeaturedScholarshipsQuery } from '../../../../store/features/scholarship/scholarshipSlice';
import { FeaturedScholarshipSlider } from './FeaturedScholarshipSlider';
import { FeaturedScholarshipsSkeleton } from './FeaturedScholarshipsSkeleton';
import { featuredScholarshipsStyles } from './styles';

export const FeaturedScholarships: React.FC = () => {
  const { isError, isLoading, data: scholarships } = useFeaturedScholarshipsQuery();
  if (isError) return null;

  if (isLoading) return <FeaturedScholarshipsSkeleton />;

  if (!scholarships || scholarships.length === 0) return null;

  return (
    <Box sx={{ py: 5 }}>
      <Box className="container-fluid" sx={{ mb: 5 }}>
        <Grid container justifyContent="space-between" alignItems="flex-end" spacing={1}>
          <Grid item>
            <Typography component="h2" variant="h3">
              Explore our
              <br />
              <Typography sx={{ bgcolor: 'warning.light' }} variant="h3" component="span">
                featured scholarships
              </Typography>
            </Typography>
          </Grid>
          <Grid item>
            <Button
              sx={featuredScholarshipsStyles.findMoreBtn}
              variant="default"
              color="primary"
              component={Link}
              to={{ pathname: APP_URLS.scholarships, search: FEATURED_FILTER_URL_PARAM }}
            >
              Find More
            </Button>
          </Grid>
        </Grid>
      </Box>
      <FeaturedScholarshipSlider scholarships={scholarships} />
    </Box>
  );
};
